<template>
  <div id="header">
    <div id="mobile-logo"></div>
    <div id="hamburger-background"></div>
    <ul id="contact-header">
      <li>
        <i class="icon-phone"></i>
        <span>tel/fax (56) 46-50-342</span>
      </li>
      <li>
        <i class="icon-email"></i>
        <span>dachbudgrudziadz@wp.pl</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Header',
};
</script>

<style scoped lang="scss">
  #header {
    position: fixed;
    top: 0; left: 0;
    width: 100%; height: 50px;
    background-color: white;

    color: #b3b3b3;
    font-family: Quicksand, sans-serif;
    font-weight: bold;

    display: flex;
    justify-content: center;
    align-items: center;

    z-index: 10;

    box-shadow: 0 3px 3px 0 rgba(0,0,0,0.4);

    ul {
      display: none;

      @media (min-width: 768px) {
        $w: 210px;
        $l: calc(50% - #{$w} / 2);

        display: block;

        position: relative;
        width: $w;
        left: $l;
      }
    }

    ul, li { list-style-type: none; margin: 0; padding: 0 5px }

    i { padding: 0 5px}

    li { text-align: left; font-size: 12px; line-height: 20px}

    @media (min-width: 768px) { box-shadow: none }
  }

  /* Variables for logo */
  $logo-width: 886px;
  $logo-height: 224px;
  $scale: 0.2;
  $size: 50px;

  #mobile-logo {
    background-image: url("../assets/logos/logo-transparent.png");
    background-size: cover;
    width: calc(#{$scale} * #{$logo-width});
    height: calc(#{$scale} * #{$logo-height});

    @media (min-width: 768px) { display: none }
  }

  #hamburger-background {
    position: absolute;
    right: 0;
    width: $size;
    height: $size;
    background-color: #f2f2f2;

    @media (min-width: 768px) { display: none }
  }
</style>
